import React from "react"
import { Carousel } from "react-responsive-carousel"

export const Table = ({ titles, rows }) => {
  return (
    <>
      {/* Desktop Table */}
      <div class="flex-col md:px-20 px:5 mt-5 hidden sm:flex">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-400">
            <table class="min-w-full">
              <thead>
                <tr>
                  {titles.map(t => (
                    <th
                      class="px-6 py-3 border-b border-gray-300 bg-gray-200 text-center text-sm leading-4 font-medium text-gray-700 capitalize tracking-wider"
                      style={{ width: `${100 / titles.length}%` }}
                    >
                      {t}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map(col => (
                  <tr
                    style={{ width: `${100 / titles.length}%` }}
                    class="bg-gray-100 hover:bg-gray-200"
                  >
                    {col.map(text => (
                      <td class="text-center border-2 px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">
                        {text}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Mobile Table */}
      <div className="my-5 block sm:hidden">
        <Carousel swipeable={false}>
          {rows.map(col => (
            <div class="bg-white w-full">
              {col.map((text, i) => (
                <div className="text-gray-800 text-center border border-b">
                  <div className="text-xs font-bold capitalize bg-blue-500 text-white py-2">
                    {titles[i]}
                  </div>
                  <div className="py-2">{text}</div>
                </div>
              ))}
            </div>
          ))}
        </Carousel>
      </div>
    </>
  )
}
